module.exports = __webpack_public_path__ + "static/img/icon_contact_whatapp.1d65ed1a.png";